import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "院线新片 · 经典佳作",
    tone: "primary",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集 · 追剧不停",
    tone: "accent",
  },
  {
    to: "/category/variety",
    icon: "ri-mic-line",
    title: "综艺",
    desc: "爆笑舞台 · 生活慢综",
    tone: "secondary",
  },
];

const toneMap: Record<string, { bg: string; text: string; ring: string }> = {
  primary: { bg: "bg-primary-100", text: "text-primary-700", ring: "group-hover:border-primary-300" },
  accent: { bg: "bg-accent-100", text: "text-accent-700", ring: "group-hover:border-accent-300" },
  secondary: {
    bg: "bg-secondary-100",
    text: "text-secondary-800",
    ring: "group-hover:border-secondary-300",
  },
};

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full px-4 pt-12 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((e) => {
          const tone = toneMap[e.tone];
          return (
            <Link
              key={e.to}
              to={e.to}
              className={`group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors ${tone.ring}`}
            >
              <span
                className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg ${tone.bg} ${tone.text}`}
              >
                <i className={`${e.icon} text-2xl`} />
              </span>
              <span className="flex-1">
                <span className="block font-heading text-lg font-bold text-foreground-950">
                  {e.title}
                </span>
                <span className="mt-0.5 block text-xs text-foreground-500">{e.desc}</span>
              </span>
              <i className="ri-arrow-right-line text-xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}